import { render } from "./VocationCenterView.vue?vue&type=template&id=010debbd"
import script from "./VocationCenterView.vue?vue&type=script&lang=js"
export * from "./VocationCenterView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__